import one360 from './one360';
import type { GeneratedProjectDocumentPdfResult, GenerateProjectDocumentPdfPayload } from '../../interfaces/make';

export async function uploadDocumentImage(
  phaseId: string,
  documentId: string,
  imageData: string,
  fileName: string,
): Promise<string | void> {
  const lastDash = phaseId.lastIndexOf('-');
  const dealId = lastDash !== -1 ? phaseId.substring(0, lastDash) : phaseId;

  const formData = new FormData();
  const base64Response = await fetch(imageData);
  const blob = await base64Response.blob();
  formData.append('File', blob, fileName);
  formData.append('DocumentId', documentId);

  const response = await one360.post<{ fileId?: string; FileId?: string }>(
    `/api/v1/ops/projects/${encodeURIComponent(dealId)}/documents`,
    formData,
  );

  return response.fileId ?? response.FileId;
}

export async function deleteProjectDocument(phaseId: string, documentId: string): Promise<void> {
  const lastDash = phaseId.lastIndexOf('-');
  const dealId = lastDash !== -1 ? phaseId.substring(0, lastDash) : phaseId;
  await one360.delete(`/api/v1/ops/projects/${encodeURIComponent(dealId)}/documents/${encodeURIComponent(documentId)}`);
}

/**
 * Serverseitige PDF-Erzeugung (ersetzt den direkten Make.com-Webhook-Aufruf im Frontend).
 * Der Endpunkt schreibt fileId + formDataInputs selbst in die HubSpot-Deal-Properties.
 */
export async function generateProjectDocumentPdf(
  dealId: string,
  documentId: string,
  payload: GenerateProjectDocumentPdfPayload,
): Promise<GeneratedProjectDocumentPdfResult> {
  return one360.post<GeneratedProjectDocumentPdfResult>(
    `/api/v1/ops/projects/${encodeURIComponent(dealId)}/documents/${encodeURIComponent(documentId)}/generated-pdf`,
    {
      documentTitle: payload.documentTitle,
      fileName: payload.fileName,
      htmlContent: payload.htmlContent || '',
      isPdfForm: payload.isPdfForm ?? false,
      signatureMissing: payload.signatureMissing ?? false,
      pdfFields: payload.pdfFields,
      signatures: payload.signatures,
      formDataInputs: payload.formDataInputs,
    },
  );
}
